import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-registration-terms-information-sign-anonymous',
  templateUrl: './registration-terms-information-sign-anonymous.component.html',
  styleUrls: ['./registration-terms-information-sign-anonymous.component.scss']
})
export class RegistrationTermsInformationSignAnonymousComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
